
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from '../../../api-gateway';
import { SnackBarService } from '../../../../cw-utils/snackbar.service';
import { Currency } from '../../../models/accreditation/currency';

@Injectable()
export class CurrencyEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    currency: Currency;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getCurrency()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getCurrency(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('currency/wAll/' + this.routeParams.id).subscribe((res: Currency) => {
                    this.currency = res;
                    this.onDataChanged.next(this.currency);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(currency): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('currency/', currency).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(currency): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('currency/', currency).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(currency): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('currency/' + currency.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }
}
